module.exports = "/matchcenter-staging/assets/images/ant1.494e15dc96642f55c109669470bd302e.png";